import {
  Component,
  ChangeDetectionStrategy,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnInit,
  ViewChild,
  OnChanges, ChangeDetectorRef, OnDestroy
} from '@angular/core';

export interface ISimpleDropdownOption {
  value: any;
  displayText: string;
}

@Component({
  selector: 'simple-dropdown',
  providers: [],
  viewProviders: [],
  templateUrl: './simple-dropdown.html'
})
export class SimpleDropdownComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() selectedValue: any;
  @Input() options: ISimpleDropdownOption[];
  @Input() containerSelector: string;
  @Input() dropValueClass: string;
  @Input() dropDownContainerClass: string;
  @Input() dropOtionsClass: string;
  @Input() disableIfOneOption: boolean = false;

  @Input()
  set isMouseOut(value: boolean) {
    if (value === true) {
      this.showList = false;
    }
  }

  @ViewChild('dropOptionsContainer', {static: false}) dropOptionsContainer: ElementRef;
  @ViewChild('valueContainer', {static: false}) valueContainer: ElementRef;

  @Output() selectedValueChange: EventEmitter<any> = new EventEmitter();
  @Output() optionCaptionClicked: EventEmitter<any> = new EventEmitter();
  @Output() onDropDownOptionsShowHide: EventEmitter<any> = new EventEmitter();

  selectedValueDisplayText: string;
  showList: boolean = false;
  isOpenOnTop: boolean = false;
  scrollingContainerElement: Element;
  boundScrollHandler: any;
  windowResizeHandler: any;

  constructor(private cdRef: ChangeDetectorRef) {
    this.windowResizeHandler = this.onWindowResize.bind(this);
  }

  ngOnInit(): void {
    if (this.containerSelector && this.containerSelector !== '') {
      this.scrollingContainerElement = document.querySelector(this.containerSelector);
    }
  }

  ngOnDestroy(): void {
    this.stopListeningToWindowEvents();
  }

  stopListeningToWindowEvents() {
    if (!this.scrollingContainerElement) {
      //we are not tracking the container scroll. allow not to
      return;
    }

    if (this.boundScrollHandler) {
      this.scrollingContainerElement.removeEventListener('scroll', this.boundScrollHandler);
      this.boundScrollHandler = null;
    }

    window.removeEventListener('resize', this.windowResizeHandler);
  }

  onWindowResize(event: Event) {
    this.calculateTopPosition();
    this.cdRef.markForCheck();
  }

  handleDocumentScrolled(event: any) {
    this.calculateTopPosition();
    this.cdRef.markForCheck();
  }

  startListeningToWindowEvents() {
    if (!this.scrollingContainerElement) {
      //we are not tracking the container scroll. allow not to
      return;
    }

    this.boundScrollHandler = this.handleDocumentScrolled.bind(this);
    this.scrollingContainerElement.addEventListener('scroll', this.boundScrollHandler);

    window.addEventListener('resize', this.windowResizeHandler);
  }

  ngAfterViewInit() {
    this.selectedValueDisplayText = this.getSelectedValueDisplayText(this.selectedValue);
  }

  ngOnChanges(changes: any): void {
    if (changes.selectedValue) {
      this.selectedValueDisplayText = this.getSelectedValueDisplayText(changes.selectedValue.currentValue);
    }
  }

  getStyle() {
    let style: any = {'visibility': this.showList ? 'visible' : 'hidden'};
    if (this.isOpenOnTop) {
      style = {...style, 'top': '0', 'transform': 'translateY(-100%)'};
    }
    return style;
  }

  byTypeVisiblity() {
    return this.dropValueClass !== 'drop-value-floating-panel';
  }

  onCaptionClick(event: any) {
    if (this.disableIfOneOption && this.options.length == 1) {
      return;
    }
    this.optionCaptionClicked.next(event);
    this.calculateTopPosition();
    this.toggleOptions();
  }

  startStopListenToWindowEvents() {
    if (this.showList === true) {
      this.startListeningToWindowEvents();
    } else {
      this.stopListeningToWindowEvents();
    }
  }

  toggleOptions() {
    this.showList = !this.showList;
    this.startStopListenToWindowEvents();
    if (this.onDropDownOptionsShowHide) {
      this.onDropDownOptionsShowHide.next(this.showList);
    }
  }

  closeOptions() {
    if (this.showList) {
      this.showList = false;
      this.startStopListenToWindowEvents();
      if (this.onDropDownOptionsShowHide) {
        this.onDropDownOptionsShowHide.next(this.showList);
      }
    }
  }

  calculateTopPosition() {
    let windowHeight = this.scrollingContainerElement.getBoundingClientRect().bottom;
    let parentRectangleBottom = this.valueContainer.nativeElement.getBoundingClientRect().bottom;
    let optionsContainerHeight = this.dropOptionsContainer.nativeElement.offsetHeight;
    let minimumNeededSpace = parentRectangleBottom + optionsContainerHeight;
    if (minimumNeededSpace > windowHeight) {
      this.isOpenOnTop = true;
    } else {
      this.isOpenOnTop = false;
    }

    this.cdRef.markForCheck();
  }

  onOptionClick(option: ISimpleDropdownOption) {
    this.selectedValue = option.value;
    this.selectedValueDisplayText = option.displayText;
    this.toggleOptions();
    this.selectedValueChange.next(option.value);
  }

  getSelectedValueDisplayText(value: any) {
    if (value) {
      let text = this.options.find(option => option.value === value).displayText;
      return text;
    } else {
      return '';
    }
  }

  onDOMMouseScroll($event: any) {

    $event.stopPropagation();

    let div = this.dropOptionsContainer.nativeElement;
    var delta = ($event.type === 'mousewheel') ? $event.wheelDelta : $event.detail * -40;
    console.log('delta: ' + delta);

    if (delta < 0 && (div.scrollHeight - div.offsetHeight - div.scrollTop) <= 0) {

      div.scrollTop = div.scrollHeight;
      $event.preventDefault();
      $event.stopPropagation();

    } else if (delta > 0 && delta > div.scrollTop) {

      div.scrollTop = 0;
      $event.preventDefault();
      $event.stopPropagation();

    }

  }

  onClickedOutside() {
    this.closeOptions();
  }
}
